import { EmptyState, Flex, Heading, InfoIcon } from '@buffer-mono/popcorn'

import styles from './MentionsError.module.css'

import type { JSX } from 'react'

interface MentionsErrorProps {
  errorMessage: string | null
}

export function MentionsError({
  errorMessage,
}: MentionsErrorProps): JSX.Element {
  return (
    <EmptyState size="xlarge" variant="warning" className={styles.emptyState}>
      <EmptyState.Icon>
        <InfoIcon />
      </EmptyState.Icon>
      <EmptyState.Heading>
        <Flex direction="column" gap="2xs" align="center">
          <Heading as="h3">{getErrorMessage(errorMessage).header}</Heading>
        </Flex>
      </EmptyState.Heading>
      <EmptyState.Description>
        {getErrorMessage(errorMessage).description}
      </EmptyState.Description>
    </EmptyState>
  )
}

const getErrorMessage = (
  errorMessage: string | null,
): { header: string; description: string } => {
  if (
    errorMessage?.includes('Actor can not access the specified channels') ||
    errorMessage?.includes('Actor can not access the organization')
  ) {
    return {
      header: 'You Don’t Have Access to Community',
      description:
        'You don’t currently have the required permissions to view mentions. To change this, ask your Admin to give you Full Posting or Admin access to each channel you’d like to access mentions for.',
    }
  }

  return {
    header: 'We are having trouble loading mentions',
    description:
      'Please try again later or contact support if the problem persists',
  }
}
